import React, { ReactNode } from 'react'

type ContactMessageDetailsContextParams = {
	type: 'configurator' | 'career' | 'project' | 'contact' | 'question'
	subject?: string
	message?: string
	emailContentCallback?: () => string | undefined
}

const ContactMessageDetailsContext = React.createContext({
	type: 'contact',
	subject: '',
	message: '',
	emailContentCallback: () => undefined
} as ContactMessageDetailsContextParams)

export const ContactMessageDetailsContextProvider: React.FunctionComponent<ContactMessageDetailsContextParams & { children: ReactNode | ReactNode[]}> = (props) => {
	const { children, ...rest } = props
	return (
		<ContactMessageDetailsContext.Provider value={{ ...rest }}>
			{children}
		</ContactMessageDetailsContext.Provider>
	)
}

export const useContactMessageDetails = () => React.useContext(ContactMessageDetailsContext)
